import React from "react";
import { Button, Tabs } from "antd";
import { observer } from "mobx-react";

import Customizer from "../Customizer.js";
import { Face, SavableFace } from "../../models/Book";
import { getSnapshot } from "mobx-state-tree";
import {
  imgsFemaleKanai,
  imgsMaleKanai,
  imgsFemaleNakagawa,
  imgsMaleNakagawa
} from "./FaceSelectionImage";

const TabPane = Tabs.TabPane;


class FaceSelection extends React.Component {
  constructor(props) {
    super();
    this.state = {
      man: SavableFace.create({
        layer1: props.book.creatorFace.layer1 !== '' ? props.book.creatorFace.layer1 : (props.artistName === "nakagawa" ? '03_face' : '01_face'),
        layer2: props.book.creatorFace.layer2 !== '' ? props.book.creatorFace.layer2 : (props.artistName === "nakagawa" ? '00_mole' : '00_mole'),
        layer3: props.book.creatorFace.layer3 !== '' ? props.book.creatorFace.layer3 : (props.artistName === "nakagawa" ? '01_cheeks' : '01_cheeks'),
        layer4: props.book.creatorFace.layer4 !== '' ? props.book.creatorFace.layer4 : (props.artistName === "nakagawa" ? '00_glasses' : '01_glasses'),
        layer5: props.book.creatorFace.layer5 !== '' ? props.book.creatorFace.layer5 : (props.artistName === "nakagawa" ? '00_hair' : '00_hair'),
        saved: Face.create({})
      }),
      woman: SavableFace.create({
        layer1: props.book.receiverFace.layer1 !== '' ? props.book.receiverFace.layer1 : (props.artistName === "nakagawa" ? '03_face' : '01_face'),
        layer2: props.book.receiverFace.layer2 !== '' ? props.book.receiverFace.layer2 : (props.artistName === "nakagawa" ? '00_mole' : '01_mole'),
        layer3: props.book.receiverFace.layer3 !== '' ? props.book.receiverFace.layer3 : (props.artistName === "nakagawa" ? '01_cheeks' : '01_cheeks'),
        layer4: props.book.receiverFace.layer4 !== '' ? props.book.receiverFace.layer4 : (props.artistName === "nakagawa" ? '00_glasses' : '01_glasses'),
        layer5: props.book.receiverFace.layer5 !== '' ? props.book.receiverFace.layer5 : (props.artistName === "nakagawa" ? '00_hair' : '00_hair'),
        saved: Face.create({})
      })
    };
  }

  save = () => {
    this.props.book.receiverFace.changeAll(getSnapshot(this.state.woman));
    this.props.book.creatorFace.changeAll(getSnapshot(this.state.man));
    this.state.woman.save();
    this.state.man.save();
    this.props.order.saveFaces();
    this.props.order.nextStep();
  };

  render() {
    const book = this.props.book;

    let imgsFemale = [];
    let imgsMale = [];
    if (this.props.artistName === "kanai") {
      imgsFemale = imgsFemaleKanai;
      imgsMale = imgsMaleKanai;
    } else if (this.props.artistName === "nakagawa") {
      imgsFemale = imgsFemaleNakagawa;
      imgsMale = imgsMaleNakagawa;
    }

    return (
      <div className="hair-selection">
        <div className="step pd-15">
          <div className="step-title">{"STEP 1：贈る相手の顔"}</div>
          <div className="step-txt">
            {"まずはプレゼントする相手の顔をつくりましょう。"}
            <br />
            {"（左右の矢印をタップすると各パーツが切り替わります）"}
          </div>
        </div>
        <Customizer imgs={imgsFemale} face={this.state.woman} />
        <div className="step step-2 pd-15">
          <div className="step-title">{"STEP 2：あなたの顔"}</div>
          <div className="step-txt">
            {"次に贈り主であるあなたの顔をつくりましょう。"}
            <br />
            {"（左右の矢印をタップすると各パーツが切り替わります）"}
          </div>
        </div>
        <Customizer imgs={imgsMale} face={this.state.man} />
        <div style={{ padding: "0px 16px" }}>
          <div className="btn-wrap">
            <button onClick={this.save} className="btn product-btn">
              {"保存して次へ"}
              <img
                src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
                className="btn-arrow"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default observer(FaceSelection);



// WEBPACK FOOTER //
// ./src/components/steps/FaceSelection.js